import type { IProcess } from '@frontend/components/interfaces';
import { fetchJson } from '@frontend/store/fetch';
import { getUrlQueryParameters } from './queryParameterUtils';

const baseUrl = '/api/requestProcesses';

export async function getRequestProcesses({
    episodeCategory,
    patientId,
    signal,
}: {
    episodeCategory?: string;
    patientId: string;
    signal: AbortSignal;
}): Promise<IProcess[]> {
    const url = getUrlQueryParameters<{ episodeCategory?: string; patientId: string }>(`${baseUrl}`, {
        episodeCategory,
        patientId,
    });

    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json.items;
}
